import React, { useState, useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux';
import { Grid } from '@mui/material';

import { openDrawer } from './../../../store/slice/MenuSlice';
import { setProductDashboardProductList, setSelectedPharmaorderId } from 'store/slice/PharmaSlice';
import { setProductList } from 'store/slice/PharmaSlice';

import { getListAPI as getProductList } from 'components/product/ProductAPI';

import ProductDashboard from '../ProductDashboard';
export default function ProductPageImpl() {
    const dispatch = useDispatch();
    const {productList} = useSelector((state)=>state.pharmaslice)
    const getProductListSuccess = (list) =>{dispatch(setProductList(list));}

    useEffect(() => {
        dispatch(setSelectedPharmaorderId(-1));
        dispatch(openDrawer(false));
        getProductList(()=>{}, getProductListSuccess);
    },[]);

    useEffect(()=>{
        dispatch(setProductDashboardProductList(
            productList.filter(productObj => 
                "planning, design approval, designing,production,design printing".includes(productObj.statusname.toLowerCase())
            ))
        )
    },[productList])

    return (
        <ProductDashboard/>
    )

}